import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_invoice_line_positionService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { invoice_id: number, invoice_line: number }): 
  Promise<{ result: { LinePosition?: number, MaxLineNumber?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoice_id)) {
      missingRequiredInParams.push('\'invoice_id\'');
    }
    if (isNil(inParams.invoice_line)) {
      missingRequiredInParams.push('\'invoice_line\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_invoice_line_position/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { invoice_id: number, invoice_line: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LinePosition?: number, MaxLineNumber?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoice_id)) {
      missingRequiredInParams.push('\'invoice_id\'');
    }
    if (isNil(inParams.invoice_line)) {
      missingRequiredInParams.push('\'invoice_line\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_invoice_line_position/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      invoice_id: number, invoice_line: number    }) {
        if(isNil(inParams.invoice_id)) {
          return true; 
        }
        if(isNil(inParams.invoice_line)) {
          return true; 
        }
      return false;
    }
}
